<template>
  <div class="breadcrumb-bar">
    <div class="breadcrumb">
      <ul class="breadcrumb">
        <li v-for="(crumb, key) in crumbs" :key="key" class="breadcrumb-item active" aria-current="page">
            <router-link :to="crumb.path">{{ crumb.text }}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    crumbs: function() {
      
      let pathArray = this.$route.matched;
      
      const breadcrumbArray = [];
      this.$loopo(pathArray, (matchItem, idx) => {
        if(Array.isArray(matchItem.meta.breadcrumb)){
          matchItem.meta.breadcrumb.forEach((_pageCrumb, _crumbIndex) => {
                breadcrumbArray.push({
                  path: (_pageCrumb.path) ? this.getPathById(_pageCrumb.path) : this.getPathById(matchItem.path),
                  text: _pageCrumb.name || matchItem.name
                });
          });
        }
      });
      return breadcrumbArray;
    }
  },
  methods: {
    getPathById (path) {
      var resPath = "";
      if (path == "") {
        resPath = "/";
      }else if(path.includes(":id")) {
        resPath = path.replace(":id", this.$route.params.id);
      } else {
        resPath = path;
      }
      return resPath;
    }
  }
};
</script>
<style scoped>
.content {
    margin-top: 30px !important;
}
.breadcrumb-bar {
   text-align: left;
    position: fixed;
    top: 55px;
    width: 100%;
    background-color: #fff;
    z-index: 10;
}
  .breadcrumb {
    width: 100%;
    position: relative;
    padding:10px;
    text-align: left;
  }
  ul {
    display: flex;
    justify-content: left;
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  ul > li {
    display: flex;
    float: left;
    height: 10px;
    width: auto;
    color:  #00BCD4;
    font-weight: bold;
    font-size: .8em;
    cursor: default;
    align-items: center;
  }
  ul > li:not(:last-child)::after {
    content: '/';
    float: right;
    font-size: .8em;
    margin: 0 .5em;
    color: #13294d;
    cursor: default;
  }
  ul > li:last-child >
  a:not(.md-button) {
      color: #3e5877 !important;
  }
 
</style>